import { useUserHasRole } from './useUserHasRole';
import { useLoginState } from './useLoginState';
import { EmptyUser } from 'model';

type LoginStatus = {
	// The user is logged in and not anonymous
	realUser: boolean;
	// The user is logged on, anon or otherwise
	loggedIn: boolean;
};

/**
 * Returns true if the user is not anonymous and is logged in
 * @returns { LoginStatus } true if the user is not anonymouse and is logged in
 */
export const useLoggedIn = (): LoginStatus => {
	const loginState = useLoginState();
	const anonymous = useUserHasRole('anonymous');
	return {
		realUser: !anonymous && loginState.loggedIn === 'valid' && loginState.user._id !== EmptyUser._id,
		loggedIn: loginState.loggedIn === 'valid'
	};
};
